var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 16.7997V8.79971C21.4996 8.44898 21.4071 8.10452 21.2315 7.80087C21.056 7.49722 20.8037 7.24507 20.5 7.06971L13.5 3.06971C13.196 2.89417 12.8511 2.80176 12.5 2.80176C12.1489 2.80176 11.804 2.89417 11.5 3.06971L4.5 7.06971C4.19626 7.24507 3.94398 7.49722 3.76846 7.80087C3.59294 8.10452 3.50036 8.44898 3.5 8.79971V16.7997C3.50036 17.1504 3.59294 17.4949 3.76846 17.7985C3.94398 18.1022 4.19626 18.3543 4.5 18.5297L11.5 22.5297C11.804 22.7052 12.1489 22.7977 12.5 22.7977C12.8511 22.7977 13.196 22.7052 13.5 22.5297L20.5 18.5297C20.8037 18.3543 21.056 18.1022 21.2315 17.7985C21.4071 17.4949 21.4996 17.1504 21.5 16.7997Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76953 7.75977L12.4995 12.8098L21.2295 7.75977",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22.8798V12.7998",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.3d81c09b1705554b785003d243512f82.svg";
export { ForwardRef as ReactComponent };